import React from "react";

interface ProductVideoProps {
    product_video: string;
    product_video_alt: string;
    product_video_title: string;
    product_video_detail: string;
}

const ProductVideo: React.FC<ProductVideoProps> = ({
    product_video,
    product_video_alt,
    product_video_title,
    product_video_detail,
}) => {
    return (
        <div className="relative h-[400px] w-full">
            <video
                src={product_video}
                autoPlay
                loop
                muted
                playsInline
                className="absolute top-0 left-0 w-full h-full object-cover z-[-1]"
                aria-label={product_video_alt}
            />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white">
                <h2 className="text-2xl font-bold mb-2 drop-shadow-lg">
                    {product_video_title}
                </h2>
                <p className="text-base drop-shadow-md">{product_video_detail}</p>
            </div>
        </div>
    );
};

export default ProductVideo;
